import makerShipImg from "./makership-io.png";
import ClimableImg from './Climable.png';
import jamming from './jamming.png';
import teaCozy from "./tea-cozy.png";
import nonaPad from "./Nonapad.png";
import ravenous from './ravenous.png';
export const projectObjects = [
    {
    img: makerShipImg,
    title: "MakerShip.io",
    tags: ["React", "Redux", "Express", "MongoDB", "HTML/CSS"],
    text: "An e-commerce app used for pairing creators with potential merchants",
    href: "https://www.makership.io/"
},
{
    img: ClimableImg,
    title: "Climable",
    tags: ["JavaScript", "Squarespace", "HTML/CSS", "API"],
    text: "Donation page linked via API of various crowd funding platforms",
    href: "https://climable.org/"
},
{
    img: jamming,
    title: "jamming",
    tags: ["React","API"],
    text: "A React app  using the Spotify API to create playlists",
    href: "https://leonn00albert.github.io/jamming/"
},
{
    img: teaCozy,
    title: "Tea Cozy",
    tags: ["React","HTML/CSS"],
    text: "A conceptual local business page",
    href: "https://leonn00albert.github.io/tea-cozy/"
},
{
    img: ravenous,
    title: "Ravenous",
    tags: ["React","API"],
    text: "Code Academy Project using Yelp api to find best dining locations",
    href: "https://leonn00albert.github.io/ravenous/"
},
{
    img: nonaPad,
    title: "NonaPad",
    tags: ["React","HTML/CSS", "Redux"],
    text: "A Drummachine & sampler made using React",
    href: "https://leonn00albert.github.io/DrumMachine/"
},
]